module.exports = __webpack_public_path__ + "img/kerala_forest_hero.c6b971d4.jpg";